module.exports = __webpack_public_path__ + "static/media/onePiece.6f51a98d.jpg";